import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const LinkRecoverPassword = styled(Link)`
  font-size: 10px;
  text-decoration: none;
  color: black;
`;
